"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoryCacheNode = void 0;
const memory_cache_node_1 = require("memory-cache-node");
function memoryCacheNode() {
    const internalCache = new memory_cache_node_1.MemoryCache(15 * 60, 1000000);
    return {
        async get(key) {
            return internalCache.retrieveItemValue(key);
        },
        async set(key, value, { ttl }) {
            if (ttl) {
                internalCache.storeExpiringItem(key, value, Number(ttl));
                return true;
            }
            internalCache.storePermanentItem(key, value);
            return true;
        },
        async del(key) {
            internalCache.removeItem(key);
            return 1;
        },
        async getOrCreate(key, creator, options) {
            const cachedValue = await this.get(key);
            if (cachedValue)
                return cachedValue;
            const value = await creator();
            await this.set(key, value, options);
            return value;
        },
        async miss(key, value, options) {
            if (await this.get(key))
                return false;
            return this.set(key, value, options);
        },
        async flushAll() {
            internalCache.clear();
        },
    };
}
exports.memoryCacheNode = memoryCacheNode;
//# sourceMappingURL=memory-cache-node.js.map